import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MessagesPage } from '@/features/messages/inbox-page';
import { KIND_FILTERS, type KindFilter } from '@/features/messages/labels';

const KINDS = KIND_FILTERS.map((option) => option.value) as [KindFilter, ...KindFilter[]];

const searchSchema = z.object({
  project: z.string().optional().catch(undefined),
  kind: z.enum(KINDS).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/messages/')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MessagesPage
      project={search.project}
      kind={search.kind ?? 'all'}
      onFilter={(next) =>
        void navigate({
          search: {
            project: next.project,
            kind: next.kind && next.kind !== 'all' ? next.kind : undefined,
          },
          replace: true,
        })
      }
    />
  );
}
